import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { UserService } from 'services';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalPoints extends React.Component<Props> {

	state = {
		point_levels: [],
		steps: [],
		form: {
			points: this.props.item?.points_history[0]?.final_amount || 0,
			point_level_id: this.props.item?.point_level_id || '',
			perfect_sanes: this.props.item?.perfect_sanes || 0,
			consecutive_perfect_sanes: this.props.item?.consecutive_perfect_sanes || 0,
			step_id: this.props.item?.step_id || ''
		}
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await UserService.admin.getSteps();
		this.setState({
			steps: res.steps || [],
			point_levels: res.point_levels || []
		});
	}

	submit = async () => {
		await UserService.admin.changePoints({
			user_id: this.props.item?.id,
			edited_by_user_id: this.props.user?.id,
			...this.state.form
		});
		Globals.showSuccess("Se ha cambiado los puntos del usuario correctamente");
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-users-points">
				{
					this.props.item?.name != '' && (
						<p><strong>Nombre:</strong> { this.props.item?.name } { this.props.item?.lastname }</p>
					)
				}
				<p><strong>Email:</strong> { this.props.item?.email }</p>
				<div className="row">
					<div className="col-md-6">
						<Input
							type="number"
							value={ this.state.form.points }
							name="points"
							label="Puntos"
							onChange={ (e: any) => this.change(e) } />
					</div>
					<div className="col-md-6">
						<Select
							placeholder="Seleccionar"
							label="Nivel"
							name="point_level_id"
							color="white"
							onChange={ (e: any) => this.change(e) }
							value={ this.state.form.point_level_id }
							options={ this.state.point_levels?.map((item: any) => {
								return {
									value: item?.id,
									label: item?.name
								}
							}) } />
					</div>
					<div className="col-md-6">
						<Select
							placeholder="Seleccionar"
							label="Escalón"
							name="step_id"
							color="white"
							onChange={ (e: any) => this.change(e) }
							value={ this.state.form.step_id }
							options={ this.state.steps?.map((item: any) => {
								return {
									value: item?.id,
									label: item?.name
								}
							}) } />
					</div>
					<div className="col-md-6">
						<Input
							type="number"
							value={ this.state.form.perfect_sanes }
							name="perfect_sanes"
							label="Sanes perfectos (Totales)"
							onChange={ (e: any) => this.change(e) } />
					</div>
					<div className="col-md-6">
						<Input
							type="number"
							value={ this.state.form.consecutive_perfect_sanes }
							name="consecutive_perfect_sanes"
							label="Sanes perfectos (Consecutivos)"
							onChange={ (e: any) => this.change(e) } />
					</div>
				</div>
				<div className="text-center">
					<Button type="submit" className="btn-save" onClick={ () => this.submit() }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalPoints);